const state = {
  user: undefined
}

const getters = {
  user: () => state.user
}

const mutations = {
  SET_USER (state, user) {
    state.user = user
  }
}

const actions = {
  /**
   * Get the user object on the server
   *
   * @returns object
   */
  get ({ commit }, that) {
    return new Promise((resolve, reject) => {
      that.$http.get(that.$api({
        target: 'user',
        conn: that.$store.getters.conn
      })).then(response => {
        if (response.data.active) {
          commit('SET_USER', response.data)
          return true
        } else {
          console.log('deactivated')
          return false
        }
      }).then(status => {
        resolve(status)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
